import { createSlice } from '@reduxjs/toolkit';

const emptyHeading = {
  title: '',
  description: '',
  textAlign: 'left',
  image: '',
  divider: '',
  position: '',
};

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    contentType: 'exercise', // exercise | program | nutrition | single
    displayMode: 'list', // list | grid | carousel
    showCover: true,

    title: '',
    description: '',
    coverImage: '',
    level: 'beginner',
    durationMinutes: null,
    calories: null,
    moves: null,
    equipment: '',
    targetMuscles: '',
    category: [],

    // access. free | paid | subscribers | members
    accessMode: 'free',
    isPaywall: false,
    price: null,
    currency: 'USD',
    freePreviewCount: 0,
    membershipTier: '',

    // the rich item collection is kept under `exercises` (the generic block save
    // strips `items`, so we never use that key on the wire).
    exercises: [],
    weeks: [],
    programMeta: {},
    nutritionItems: [],
    nutritionMeta: {},

    heading: { ...emptyHeading },
  },
  blockDesign: {},
  containerDesign: {},
};

export const workoutSlice = createSlice({
  name: 'workout',
  initialState,
  reducers: {
    workoutStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;
      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const c = blockContent ?? {};
      const { containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;
      state.containerDesign = containerDesign ?? {};

      let contentType = c.contentType ?? 'exercise';
      if (contentType === 'workout') contentType = 'exercise';

      state.blockContent = {
        contentType,
        displayMode: c.displayMode ?? 'list',
        showCover: c.showCover !== false,

        title: c.title ?? '',
        description: c.description ?? '',
        coverImage: c.coverImage ?? '',
        level: c.level ?? 'beginner',
        durationMinutes: c.durationMinutes ?? null,
        calories: c.calories ?? null,
        moves: c.moves ?? null,
        equipment: c.equipment ?? '',
        targetMuscles: c.targetMuscles ?? '',
        category: Array.isArray(c.category) ? c.category : [],

        accessMode: c.accessMode ?? (c.isPaywall ? 'paid' : 'free'),
        isPaywall: c.isPaywall ?? false,
        price: c.price ?? null,
        currency: c.currency ?? 'USD',
        freePreviewCount: c.freePreviewCount ?? 0,
        membershipTier: c.membershipTier ?? '',

        exercises: Array.isArray(c.items) ? c.items : Array.isArray(c.exercises) ? c.exercises : [],
        weeks: Array.isArray(c.weeks) ? c.weeks : [],
        programMeta: c.programMeta ?? {},
        nutritionItems: Array.isArray(c.nutritionItems) ? c.nutritionItems : [],
        nutritionMeta: c.nutritionMeta ?? {},

        heading: {
          title: c.heading?.title ?? '',
          description: c.heading?.description ?? '',
          textAlign: c.heading?.textAlign ?? 'left',
          image: c.heading?.image ?? '',
          divider: c.heading?.divider ?? '',
          position: c.heading?.position ?? '',
        },
      };
    },
    workoutClear: () => initialState,

    workoutUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    workoutUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    workoutUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { workoutStore, workoutClear, workoutUpdateIsLoading, workoutUpdateIsActive, workoutUpdateBlockContent } = workoutSlice.actions;

export const selectWorkoutIsLoading = (state) => state.workout.isLoading;
export const selectWorkoutId = (state) => state.workout.id;
export const selectWorkoutUID = (state) => state.workout.uid;
export const selectWorkoutBlockContent = (state) => state.workout.blockContent;

export default workoutSlice.reducer;
